import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { resolveInitialLocale } from '@/utils/locale-preference'

Vue.use(VueI18n)

// Supported locale keys.
const localeKeys = ['zh-TW', 'en', 'ko']

// Load locale message bundles by key.
const messages = {}
for (const key of localeKeys) {
  messages[key] = require(`./locales/${key}/index.js`).default
}

export default new VueI18n({
  locale: resolveInitialLocale(),
  messages,
  silentTranslationWarn: true, // Ignore missing-translation warnings in runtime.
  missing:(locale, key, result, vm, values) => {
    return locale||"";
  }
})
